<script>
export default {
  name: 'Claim',
};
</script>

<template>
  <div class="upcoming-card main-block my-9 claim">
    <div class="claim__title">How to claim your SIDUS ACADEMY NFTs</div>
    <hr />
    <div class="claim__text">
      Users who bought NFTs in the presale will be able to claim their NFTs on January 12th through
      this same website they made their purchase.
    </div>
    <div class="claim__img">
      <img src="@/assets/img/launchpad/claim_example.png" alt="claim example" />
    </div>
  </div>
</template>

<style lang="scss">
.claim {
  font-weight: 600;

  &__title {
    font-size: 2.8rem;
  }

  &__text {
    font-size: 1.8rem;
    margin-bottom: 3rem;
  }

  &__img {
    text-align: center;

    img {
      max-width: 100%;
    }
  }

  hr {
    margin: 4rem 0 3rem;
    border-top: 2px solid #a0a5d5;
    opacity: 0.3;
  }
}
</style>
